import React, { useMemo } from 'react';
import { Select } from '@televet/kibble-ui/build/components/Select';
import { MenuItemProps } from '@televet/kibble-ui/build/components/Menu/components/MenuItem';
import { AvailableFrequencies } from 'pages/Tasks/types';

interface RepeatIntervalSelectProps {
  repeatInterval: AvailableFrequencies;
  setRepeatInterval: (val: AvailableFrequencies) => void;
}

const DEFAULT_OPTION: MenuItemProps = { label: 'Does not repeat', value: 'Does not repeat' };
const allowedRepeatIntervals: AvailableFrequencies[] = ['Daily', 'Weekly'];

const RepeatIntervalSelect: React.FC<RepeatIntervalSelectProps> = ({
  repeatInterval,
  setRepeatInterval,
}) => {
  const repeatIntervalOptions: MenuItemProps[] = useMemo(
    () =>
      [
        {
          ...DEFAULT_OPTION,
          isSelected: !repeatInterval || repeatInterval === DEFAULT_OPTION.value,
        },
      ].concat(
        allowedRepeatIntervals.map((interval) => {
          return {
            label: interval,
            value: interval,
            isSelected: repeatInterval === interval,
          };
        }),
      ),
    [repeatInterval],
  );

  return (
    <Select
      data-testid="custom-task-modal-interval-select"
      listProps={{
        onSelect: (selectedItem: MenuItemProps): void => setRepeatInterval(selectedItem.value as AvailableFrequencies),
      }}
      placeholder="Repeat"
      label="Repeat"
      options={repeatIntervalOptions}
      value={repeatInterval}
    />
  );
};

export default RepeatIntervalSelect;
